<template>
  <v-expansion-panel>
    <v-expansion-panel-content>
      <template slot="header">
        <div>
          <strong>API - Busca os registros nas tabelas ou views informadas</strong>
          <small>(ENDPOINT: {{ `${endPoint}/dynamic-select/select-table-or-view` }} | MÉTODO: GET)</small>
        </div>
      </template>
      <v-divider></v-divider>
      <v-card class="pa-3">
        <v-card-title primary-title>Requisição</v-card-title>
        <v-data-table
          :headers="headersRequest"
          :items="requestItemsTableManager"
          :pagination.sync="pagination"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.param }}</td>
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.format }}</td>
            <td>{{ props.item.required }}</td>
            <td>{{ props.item.options }}</td>
            <td>{{ props.item.sample }}</td>
          </template>
        </v-data-table>
        <v-card-title primary-title>Resposta: Retorna um ou mais dados da tabela informada nos parâmetros.</v-card-title>
      </v-card>
    </v-expansion-panel-content>
    <v-expansion-panel-content>
      <template slot="header">
        <div>
          <strong>API - Atualização de Chamado </strong>
          <small>(ENDPOINT: {{ `${endPoint}/called-update` }} | MÉTODO: POST)</small>
        </div>
      </template>
      <v-divider></v-divider>
      <v-card class="pa-3">
        <v-card-title primary-title>Requisição</v-card-title>
        <v-data-table
          :headers="headersRequest"
          :items="requestItems"
          :pagination.sync="pagination"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.param }}</td>
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.format }}</td>
            <td>{{ props.item.required }}</td>
            <td>{{ props.item.options }}</td>
            <td>{{ props.item.sample }}</td>
          </template>
        </v-data-table>
        <v-card-title primary-title>Resposta - Exemplo(JSON)</v-card-title>
        <code>
  {
    "called_id": "1",
    "title": "Testando direto via api",
    "date": {
        "date": "2020-11-29 16:15:01.000000",
        "timezone_type": 1,
        "timezone": "-03:00"
    },
    "worked_hours": 780,
    "description": "Testando direto via api",
    "user_id": 1,
    "before_called_status_id": 1,
    "after_called_status_id": 1,
    "before_priority_id": 2,
    "after_priority_id": 2,
    "updated_at": "2020-11-29 19:36:16",
    "created_at": "2020-11-29 19:36:16",
    "id": 13
  }
        </code>
      </v-card>
    </v-expansion-panel-content>
    <v-expansion-panel-content>
      <template slot="header">
        <div>
          <strong>API - Inserção de dados na tabela load_log </strong>
          <small>(ENDPOINT: {{ `${endPoint}/insert-load-log` }} | MÉTODO: POST)</small>
        </div>
      </template>
      <v-divider></v-divider>
      <v-card class="pa-3">
        <v-card-title primary-title>Requisição</v-card-title>
        <v-data-table
          :headers="headersRequest"
          :items="requestItemsLoadConf"
          :pagination.sync="pagination"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.param }}</td>
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.format }}</td>
            <td>{{ props.item.required }}</td>
            <td>{{ props.item.options }}</td>
            <td>{{ props.item.sample }}</td>
          </template>
        </v-data-table>
        <v-card-title primary-title>Resposta: Registro inserido com sucesso!</v-card-title>
      </v-card>
    </v-expansion-panel-content>
    <v-expansion-panel-content>
      <template slot="header">
        <div>
          <strong>API - Inserção de dados na tabela load_notification </strong>
          <small>(ENDPOINT: {{ `${endPoint}/insert-load-notification` }} | MÉTODO: POST)</small>
        </div>
      </template>
      <v-divider></v-divider>
      <v-card class="pa-3">
        <v-card-title primary-title>Requisição</v-card-title>
        <v-data-table
          :headers="headersRequest"
          :items="requestItemsLoadNotification"
          :pagination.sync="pagination"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.param }}</td>
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.format }}</td>
            <td>{{ props.item.required }}</td>
            <td>{{ props.item.options }}</td>
            <td>{{ props.item.sample }}</td>
          </template>
        </v-data-table>
        <v-card-title primary-title>Resposta: Registro inserido com sucesso!</v-card-title>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'settings',
  data() {
    return {
      endPoint: process.env.API_ENDPOINT,
      titleBox: 'Configurações',
      pagination: { rowsPerPage: -1 },
      headersRequest: [
        { text: 'Parâmetro', sortable: false },
        { text: 'Tipo', sortable: false },
        { text: 'Formato', sortable: false },
        { text: 'Obrigatório', sortable: false },
        { text: 'Opções disponíveis', sortable: false },
        { text: 'Exemplo', sortable: false },
      ],
      requestItems: [
        {
          param: 'token',
          type: 'Texto',
          format: 'Padrão 60 caracteres',
          required: 'Sim',
          options: 'Sem opções',
          sample: '11GROe1Ry5Fy3WCDADO3YeX5W7ABRKX1eXLckrYzA7OOmdoQcx8jhCDy0H9M',
        },
        {
          param: 'called_id',
          type: 'Inteiro',
          format: 'Sem formato',
          required: 'Sim',
          options: 'Sem opções',
          sample: '1',
        },
        {
          param: 'title',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'Sem opções',
          sample: 'Finalizando o chamado',
        },
        {
          param: 'date',
          type: 'Data',
          format: 'RFC 2822 date time',
          required: 'Não',
          options: 'Sem opções',
          sample: 'Sun Nov 29 2020 13:24:01 GMT-0300',
        },
        {
          param: 'worked_hours',
          type: 'Texto',
          format: 'Hora sem os dois pontos',
          required: 'Não',
          options: 'Sem opções',
          sample: 'Exemplo para 10 horas (1000), exemplo para 5 horas (0500), exemplo para 30 minutos (0030)',
        },
        {
          param: 'description',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'Sem opções',
          sample: 'Descrição do chamado.',
        },
        {
          param: 'called_status',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'aberto | fechado',
          sample: 'aberto',
        },
        {
          param: 'priority',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'urgente | normal | baixo',
          sample: 'urgente',
        },
      ],
      requestItemsLoadConf: [
        {
          param: 'token',
          type: 'Texto',
          format: 'Padrão 60 caracteres',
          required: 'Sim',
          options: 'Sem opções',
          sample: '11GROe1Ry5Fy3WCDADO3YeX5W7ABRKX1eXLckrYzA7OOmdoQcx8jhCDy0H9M',
        },
        {
          param: 'load_conf_id',
          type: 'Inteiro',
          format: 'Sem formato',
          required: 'Sim',
          options: 'Sem opções',
          sample: '1',
        },
        {
          param: 'ds_job',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'Sem opções',
          sample: 'CARGA_TSTE',
        },
        {
          param: 'ds_map',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'Sem opções',
          sample: 'Sem exemplo',
        },
        {
          param: 'st_load',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'Sem opções',
          sample: 'erro',
        },
        {
          param: 'dt_start_load',
          type: 'Data',
          format: 'YYYY-MM-DD HH:mm:ss',
          required: 'Não',
          options: 'Sem opções',
          sample: '2021-11-16 12:00:00',
        },
        {
          param: 'dt_end_load',
          type: 'Data',
          format: 'YYYY-MM-DD HH:mm:ss',
          required: 'Não',
          options: 'Sem opções',
          sample: '2021-11-16 12:00:00',
        },
        {
          param: 'tx_log',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'Sem opções',
          sample: 'erro na carga dos dados, campo texto era esperado para a coluna nom_funcionario',
        },
      ],
      requestItemsLoadNotification: [
        {
          param: 'token',
          type: 'Texto',
          format: 'Padrão 60 caracteres',
          required: 'Sim',
          options: 'Sem opções',
          sample: '11GROe1Ry5Fy3WCDADO3YeX5W7ABRKX1eXLckrYzA7OOmdoQcx8jhCDy0H9M',
        },
        {
          param: 'load_log_id',
          type: 'Inteiro',
          format: 'Sem formato',
          required: 'Sim',
          options: 'Sem opções',
          sample: '1',
        },
        {
          param: 'ds_notification_type',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'Sem opções',
          sample: 'whatsApp',
        },
        {
          param: 'ds_text',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'Sem opções',
          sample: 'Foi identificado um erro na carga do projeto Ciclos teste.',
        },
        {
          param: 'ds_group',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'Sem opções',
          sample: 'AER',
        },
        {
          param: 'dt_log_notification',
          type: 'Data',
          format: 'YYYY-MM-DD HH:mm:ss',
          required: 'Não',
          options: 'Sem opções',
          sample: '2021-11-16 12:00:00',
        },
        {
          param: 'fl_send_notification',
          type: 'Inteiro',
          format: 'Sem formato',
          required: 'Não',
          options: 'Sem opções',
          sample: '1',
        },
      ],
      requestItemsTableManager: [
        {
          param: 'token',
          type: 'Texto',
          format: 'Padrão 60 caracteres',
          required: 'Sim',
          options: 'Sem opções',
          sample: '11GROe1Ry5Fy3WCDADO3YeX5W7ABRKX1eXLckrYzA7OOmdoQcx8jhCDy0H9M',
        },
        {
          param: 'tableName',
          type: 'Texto',
          format: 'Sem formato',
          required: 'Não',
          options: 'Sem opções',
          sample: 'call_histories',
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/features/settings/Settings.vue